import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import { Close, ArrowDropUp, ArrowDropDown } from "@material-ui/icons";
import { Slider, FormLabel, FormControl } from "@mui/material";
import { Grid, Typography } from "@material-ui/core";
import { connect } from "react-redux";

function PriceRange(props) {
  const [selectedCurrency, setSelectedCurrency] = React.useState(
    localStorage.getItem("selectedCurrency")
      ? localStorage.getItem("selectedCurrency")
      : null
  );

  const [anchorEl, setAnchorEl] = React.useState([0, 1000]);

  function valuetext(value) {
    return `${value} ${selectedCurrency}`;
  }

  React.useEffect(() => {
    if (props.vendorCurrency) setSelectedCurrency(props.vendorCurrency);
    else setSelectedCurrency(props.currency);
  }, [props.vendorCurrency, props.currency]);

  // function rangetext(arr) {
  //   return arr
  //     ? `${arr[0]} ${selectedCurrency} - ${arr[1]} ${selectedCurrency}`
  //     : "-";
  // }

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  const handleUpdate = (e) => {
    setAnchorEl(e.target.value);
  };

  React.useEffect(() => {
    if (anchorEl && anchorEl[0] > 0) {
      const delayUpdate = setTimeout(() => {
        if (props.onChange) props.onChange(anchorEl);
      }, 1000);
      return () => {
        clearTimeout(delayUpdate);
      };
    }
  }, [anchorEl]);

  // const handleChange = (val) => {
  //   if (props.onChange) props.onChange(val);
  // };
  // const open = Boolean(anchorEl);
  // const id = open ? "simple-popover" : undefined;

  // const handleClear = (e) => {
  //   e.stopPropagation();
  //   handleChange(props.defaultValue);
  //   handleReset();
  // };
  // const handleReset = () => {
  //   if (props.onReset) props.onReset();
  // };

  return (
    <FormControl
      sx={{
        "&.MuiFormControl-root": {
          display: "block",
        },
        padding: "0 1rem",
      }}
    >
      <FormLabel
        id="price-range"
        sx={{
          display: "block",
          fontWeight: "700",
          textAlign: "start",
          color: "#000000",
        }}
      >
        Price Range
      </FormLabel>
      <Slider
        // value={props.value}
        aria-label="Max Fly Duration"
        // defaultValue={props.defaultValue}
        getAriaValueText={valuetext}
        value={anchorEl}
        step={1}
        sx={{
          "& .MuiSlider-track": {
            color: "#00846A",
          },
          "& .MuiSlider-thumb": {
            backgroundColor: "white",
            border: "1px solid #00846A",
          },
        }}
        // marks
        min={props.minValue ? props.minValue : 0}
        max={props.maxValue ? props.maxValue : 10000}
        valueLabelDisplay="auto"
        onChange={handleUpdate}
      />
    </FormControl>
  );
}

PriceRange.defaultProps = {
  value: [0, 100],
};

const mapStateWithProps = (state) => {
  let commissionType = "";
  let commissionValue = 0;
  let vendorCurrency;
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
    vendorCurrency = state.vendor.vendorDetail.currency;
  }
  let adminCommissionType = "Fixed";
  let adminCommissionValue = 0;
  if (
    state.admin &&
    state.admin.commission &&
    state.admin.commission.commissionType
  ) {
    adminCommissionType = state.admin.commission.commissionType;
    adminCommissionValue = state.admin.commission.commissionValue;
  }
  return {
    auth: state.user.auth,
    userDetails: state.user.userDetails,
    passengers: state.flight.passengers,
    old_passengers: state.flight.old_pass,
    email: state.flight.email,
    phone: state.flight.phone,
    currency: state.flight.currency ? state.flight.currency : "",
    listValid: state.flight.passengerListValid,
    commissionType: commissionType,
    commissionValue: commissionValue,
    vendorCurrency,
    adminCommissionType,
    adminCommissionValue,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateWithProps, mapDispatchToProps)(PriceRange);
